import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import './Resume.css'
import Fade from 'react-reveal/Fade';

const Resume = () => {
    return (
        <div className="container mt-5" id="resume">
            <div className="row">
                <h3 className=""><span style={{ borderBottom: '3px solid green' }}>RESUME</span></h3>
                <div className="col-md-4 mt-5">
                    <Fade left>
                        <h5 className=""><span style={{ borderLeft: '3px solid green' }}><span className="ms-2">Education</span></span></h5>
                        <div className="mt-5">
                            <h5>B.Sc in Computer Science & Engineering</h5>
                            <h5>Premier University</h5>
                            <h5>Chattogram, Bangladesh</h5>
                            <h5>(07/19 – present)</h5>
                        </div>
                    </Fade>
                </div>
                <div className="col-md-4 justify-content-md-center align-content-md-center d-flex mt-5">
                    <div>
                        <Fade bottom>
                            <div>
                                <h5 className="ms-md-4"><span style={{ borderLeft: '3px solid green' }}><span className="ms-2">Courses</span></span></h5>
                            </div>
                            <div className="mt-5">
                                <Timeline>
                                    <TimelineItem>
                                        <TimelineSeparator>
                                            <TimelineDot />
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent>Complete Web Development Course  with Jhankar Mahabub</TimelineContent>
                                    </TimelineItem>
                                    <TimelineItem>
                                        <TimelineSeparator>
                                            <TimelineDot />
                                        </TimelineSeparator>
                                        <TimelineContent>Full Stack Web Development at Bohubrihi</TimelineContent>
                                    </TimelineItem>
                                </Timeline>
                            </div>
                        </Fade>
                    </div>
                </div>
                <div className="col-md-4 mt-5">
                    <Fade right>
                        <h5 className=""><span style={{ borderLeft: '3px solid green' }}><span className="ms-2">Coding Skills</span></span></h5>
                        <div className="mt-5">
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: "100%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">HTML</div>
                            </div>
                            <div className="progress mt-3">
                                <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: "85%" }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100">CSS</div>
                            </div>
                            <div className="progress mt-3">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "80%" }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">javascript</div>
                            </div>
                            <div className="progress mt-3">
                                <div className="progress-bar progress-bar-striped bg-warning" role="progressbar" style={{ width: "75%" }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">REACT JS</div>
                            </div>
                            <div className="progress mt-3">
                                <div className="progress-bar progress-bar-striped bg-info" role="progressbar" style={{ width: "50%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">EXPRESS JS</div>
                            </div>
                            <div className="progress mt-3">
                                <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: "50%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">MONGODB</div>
                            </div>
                        </div>
                        <div className="mt-3 ms-auto">
                            <a href="https://drive.google.com/uc?export=download&id=1NYN3mcMTZdlzM-gwPlI_L6hfkg1OddZ6" className="btn btn-success">Download Resume</a>
                        </div>
                    </Fade>
                </div>
            </div>
        </div>
    );
};

export default Resume;